import { calcWeightedPercent } from './calcWeightedPercent'

export const calcWeightedPair = <T>(
  reports: T[],
  planKey: keyof T,
  actualKey: keyof T,
  plannedSalesKey: keyof T,
  actualsSalesKey: keyof T
) => {
  return {
    plans: calcWeightedPercent(reports, planKey, plannedSalesKey),
    actuals: calcWeightedPercent(reports, actualKey, actualsSalesKey),
  }
}
